/**
 * Cliente del catálogo de voces (presets) para selects del BO.
 * Hoy: la voz de la entrevistadora de Scout (ver docs/scout-plan/04).
 */
import { get } from './_core.js';

export interface AdminPersona {
  id: string;
  slug: string;
  name: string;
  description: string;
  voiceId: string;
  category: string | null;
  accent: string | null;
}

export async function fetchAdminPersonas(): Promise<AdminPersona[]> {
  const res = await get<AdminPersona[]>('/admin/personas');
  return res.data;
}
